export enum StatusBarIcon {
  Waste = 'icon-trash-small',
  Qa = 'icon-quality-assurance',
  Print = 'icon-print-outline',
  ForwardWaste = 'icon-recycling'
}
